// extracted by mini-css-extract-plugin
export default {"container":"RoomDetails_container__ZxqZ6"};